import { render, staticRenderFns } from "./simpleDateInput.vue?vue&type=template&id=2fbc5b72&"
import script from "./simpleDateInput.vue?vue&type=script&lang=js&"
export * from "./simpleDateInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports